import {useState} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import {
	selectPrevMode,
	selectContacts,
	createChatRoom,
	setMode
} from '../messageCenterSlice'
import Select from "react-select"
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import {capitalize} from '../../../util/util'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'

const accountTypeValueColor = type =>({
	trainer:'rgba(240, 115, 144,0.2)',
	gym:'rgba(142, 89, 240,0.2)',
	client:'rgba(99, 191, 98,0.2)'
}[type])

const ContactSelector = ({heading,maxMenuHeight,completeText,cancelText,onCancel,onComplete,exclude})=>{
	const {status:contactsStatus,byType:contactsByType} = useSelector(selectContacts)
	const [status,setStatus] = useState('idle')
	const groupTypes = Object.keys(contactsByType)
	//map contacts to data format needed for react-select
	const groupedSelectOptions = Object.entries(contactsByType).map(([contactType,contacts])=>(
		{
			label:`${contactType}${contacts.length>1?'s':''}`,
			options:contacts.filter(contact=>!(exclude||[]).includes(contact.user_id_number)).map(contact=>({
				label:contact.user_name,
				value:contact.user_id_number,
				type:contactType
			}))
		}
	))
	const [selectedContacts,setSelectedContacts] = useState([])
	const prevMode = useSelector(selectPrevMode)
	const handleCancel = () => { 
		setSelectedContacts([])
		onCancel()
	}
	const handleCreate = () => {
		setStatus('pending')
		onComplete(selectedContacts).then(()=>{
			setSelectedContacts([])
			setStatus('idle')
		})
	}
	if(contactsStatus === 'pending') return <CenteredLoader/>
	return (
		<div>
			<div>{heading}:</div>
			<div className="d-flex align-items-center">
				{groupTypes.map(t=>(
					<div className="d-flex align-items-center mr-3">
						<span style={{
							backgroundColor:accountTypeValueColor(t),
							border:'1px solid #ccc',
							display:'inline-block',
							borderRadius:'100%',
							marginRight:'4px',
							width:'16px',
							height:'16px'
						}}/>
						{capitalize(t)}
					</div>
				))}
			</div>
			<Select 
				value={selectedContacts}
				onChange={selectedOptions=>{
					setSelectedContacts(selectedOptions)
				}}
				maxMenuHeight={maxMenuHeight}
				options={groupedSelectOptions} 
				styles={{
					multiValue:(provided,{data})=>({
						...provided,
						backgroundColor:accountTypeValueColor(data.type),
						border:'1px solid #ccc'
					})
				}}
				isMulti
			/>
			<div className="text-right mt-2">
				<Button 
					disabled={status==='pending'}
					variant="outline-danger" 
					onClick={handleCancel} 
					size="sm"
				>
					{cancelText}
				</Button>
				<Button 
					disabled={status==='pending'}
					onClick={handleCreate} 
					variant="outline-primary"
					className="ml-2" 
					size="sm"
				>
					{
						status === 'pending' ? 
						<Spinner animation="border" size="sm"/>:
						completeText
					}
				</Button>
			</div>
		</div>
	)
}

export default ContactSelector